// Configuración de variables de entorno para VortexDocs Web
// Este archivo maneja las variables de entorno de manera segura

const config = {
  // API de OpenRouter
  OPENROUTER_API_KEY: import.meta.env.VITE_OPENROUTER_API_KEY || 'your-api-key-here',
  OPENROUTER_BASE_URL: 'https://openrouter.ai/api/v1',
  
  // Configuración de la aplicación
  APP_NAME: import.meta.env.VITE_APP_NAME || 'VortexDocs Web',
  APP_VERSION: import.meta.env.VITE_APP_VERSION || '1.0.0',
  
  // Configuración de Firebase (si es necesaria)
  FIREBASE_CONFIG: {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID
  }
};

// Función para validar la configuración
export function validateConfig() {
  const requiredKeys = ['OPENROUTER_API_KEY'];
  const missingKeys = requiredKeys.filter(key => !config[key] || config[key] === 'your-api-key-here');
  
  if (missingKeys.length > 0) {
    console.warn('⚠️ Configuración incompleta. Faltan las siguientes variables de entorno:', missingKeys);
    console.warn('📝 Crea un archivo .env en la raíz del proyecto con las siguientes variables:');
    missingKeys.forEach(key => {
      console.warn(`   ${key}=tu-valor-aqui`);
    });
    return false;
  }
  
  return true;
}

// Función para obtener la configuración
export function getConfig() {
  return config;
}

// Función para obtener una variable específica
export function getConfigValue(key) {
  return config[key];
}

export default config; 